import React from 'react';
import { IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { parameterStatuses } from '../../constants';

export const ClearRejectedConfigurationParameterButton = ({ status: { processed, actual }, onClearRejected, onCancelClick, disabled }) => {
  const isVisible = processed === parameterStatuses.REJECTED || processed === parameterStatuses.MODIFIED
  let onClearClick = processed === parameterStatuses.REJECTED ? onClearRejected : onCancelClick

  if (processed === parameterStatuses.MODIFIED && actual === parameterStatuses.REJECTED) {
    onClearClick = () => {
      onCancelClick();
      onClearRejected();
    };
  }

  return (
    isVisible
    && (
    <IconButton
      size="large"
      disabled={disabled}
      onClick={onClearClick}
    >
      <Clear />
    </IconButton>
)
  );
}
